// 서버 응답 날짜(문자열/Date)를 KST 기준 YYYY-MM-DD 로 포맷
// 서버 포맷: "YYYY-MM-DD HH:mm:ss" 또는 "YYYY-MM-DDTHH:mm:ss+09:00"
// toISOString() 은 UTC 변환으로 KST 자정에서 하루가 밀리므로 사용 금지
export const formatYMD = value => {
  if (!value) return 'N/A';
  if (typeof value === 'string' && value.length >= 10) return value.slice(0, 10);
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return 'N/A';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
